import React from 'react';
import { ExtensionComponentProps } from '@sharefiledev/sharefile-appshell';
import { Spin } from 'antd';

const LazyClientSettingsPage = React.lazy(() => import('./Settings/ClientSettings'));
export const AsyncClientSettingsPage: React.FC<ExtensionComponentProps<'no-op'>> = ({
	piral,
	...props
}) => (
	<React.Suspense fallback={<Spin />}>
		<LazyClientSettingsPage {...props} piral={piral} />
	</React.Suspense>
);

const LazyFolders = React.lazy(() => import('./blocks/FileViewerBlock'));
export const AsyncFolders: React.FC<ExtensionComponentProps<'no-op'>> = ({
	piral,
	...props
}) => (
	<React.Suspense fallback={<Spin />}>
		<LazyFolders {...props} piral={piral} />
	</React.Suspense>
);
